import React from 'react';

import { Redirect } from 'expo-router';
import { MenuSection } from 'features/menu/pages/menu-object-page/menu-section';
import { MenuSectionPage } from 'features/menu/pages/menu-section-page/menu-section-page';
import { useStoreRequired } from 'features/store/hooks/use-store-required';
import { View } from 'react-native';

import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { routes } from 'utils/routing';

export default function MenuSectionPageById() {
  const { noStoreSelected } = useStoreRequired();

  if (noStoreSelected) {
    return <Redirect href={routes.menu} />;
  }

  return <MenuSectionInner />;
}

const MenuSectionInner = React.memo(() => {
  const enableUnifiedMenu = useEnableUnifiedMenu();
  return (
    <View testID="menu-section-page" style={{ flex: 1 }}>
      {enableUnifiedMenu ? <MenuSectionPage /> : <MenuSection />}
      <FloatingViewCartFab safeAreaBottom />
    </View>
  );
});
